import React from "react";

const About = () => {
  return (
    <div className="about-wrapper" id="about">
      <h2>About Me</h2>
      <p>
        My name is lanre and i am a software developer, i build UI with
        react/vue, design with AdobeXD, interact with the blockchain using
        solidity and build fullstack applications with NodeJs. I am innovative
        with impeccable communication and interpersonal skill above all i love
        to build beautiful user interface. You can hit me up for
        full-time,contract,freelance roles larry_coal[at]outlook.com
      </p>
    </div>
  );
};

export default About;
